const pendingRmcs = (stats, process = true) => {
  if (process) {
    return stats?.departments?.reduce(
      (value, department) => value + department.nonComplianceReports?.pending,
      0,
    )
  }

  return stats?.questionnaires?.reduce(
    (value, questionnaire) =>
      value + questionnaire.nonComplianceReports?.pending,
    0,
  )
}

export default pendingRmcs
